import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfServiceBotIconProps extends SvgIconProps {}

/**
 * Component displays list view  svg icon
 * @param props -CcfListViewIconProps
 * @returns commit svg icon
 * @example - <CcfListViewIcon/>
 */
export function CcfServiceBotIcon(props: CcfServiceBotIconProps) {
  return (
    <SvgIcon {...props} width="20" height="17" viewBox="0 0 20 17" fill="none">
      <path
        d="M16.6666 6.49996V4.83329C16.6666 3.91663 15.9166 3.16663 14.9999 3.16663H12.4999C12.4999 1.78329 11.3833 0.666626 9.99992 0.666626C8.61658 0.666626 7.49992 1.78329 7.49992 3.16663H4.99992C4.08325 3.16663 3.33325 3.91663 3.33325 4.83329V6.49996C1.94992 6.49996 0.833252 7.61663 0.833252 8.99996C0.833252 10.3833 1.94992 11.5 3.33325 11.5V14.8333C3.33325 15.75 4.08325 16.5 4.99992 16.5H14.9999C15.9166 16.5 16.6666 15.75 16.6666 14.8333V11.5C18.0499 11.5 19.1666 10.3833 19.1666 8.99996C19.1666 7.61663 18.0499 6.49996 16.6666 6.49996ZM6.24992 8.58329C6.24992 7.89163 6.80825 7.33329 7.49992 7.33329C8.19158 7.33329 8.74992 7.89163 8.74992 8.58329C8.74992 9.27496 8.19158 9.83329 7.49992 9.83329C6.80825 9.83329 6.24992 9.27496 6.24992 8.58329ZM13.3333 13.1666H6.66658V11.5H13.3333V13.1666ZM12.4999 9.83329C11.8083 9.83329 11.2499 9.27496 11.2499 8.58329C11.2499 7.89163 11.8083 7.33329 12.4999 7.33329C13.1916 7.33329 13.7499 7.89163 13.7499 8.58329C13.7499 9.27496 13.1916 9.83329 12.4999 9.83329Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default CcfServiceBotIcon;
